// extracted by mini-css-extract-plugin
export default {"tooltip":"kp-z","sharingV2":"lp-z","sharingIconsV2":"mp-z","links":"np-z","link":"op-z","facebookV2":"pp-z","twitterV2":"qp-z","pinterestV2":"rp-z"};